export const BG_IMAGES = {
  institut:'https://res.cloudinary.com/dxbfpabjs/image/upload/v1770656248/IMG_9339_1_slar3y.jpg',
  // Logo pour le Lycée Français
  lyceeFrancais: 'https://res.cloudinary.com/dxbfpabjs/image/upload/v1767133677/18082000-DJI_20000818060052_0359_D-min_ydunsu.jpg',
  
  // Logo pour le Lycée Ivoirien
  lyceeIvoirien: 'https://res.cloudinary.com/dxbfpabjs/image/upload/v1770652736/1703069462030_qscdhc.jpg',
  
  // Logo pour Maternelle & Primaire
  maternellePrimaire: 'https://res.cloudinary.com/dxbfpabjs/image/upload/v1767179511/18082000-DJI_20000818055508_0343_D_p6dzmx.jpg',

}